function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M13,0 L1,0 C0.448,0 0,0.448 0,1 L0,8 C0,8.552 0.448,9 1,9 L7.5,9 C7.707,9 7.824,8.765 7.701,8.6 L6.2,6.6 C5.869,6.158 5.958,5.531 6.4,5.2 C6.843,4.869 7.469,4.958 7.8,5.4 L10.8,9.4 C10.812,9.417 10.813,9.436 10.824,9.452 C10.848,9.486 10.867,9.52 10.885,9.557 C10.907,9.599 10.922,9.642 10.937,9.688 C10.951,9.729 10.965,9.769 10.974,9.811 C10.981,9.852 10.983,9.891 10.986,9.933 C10.988,9.956 11,9.976 11,10 C11,10.024 10.988,10.044 10.986,10.067 C10.983,10.109 10.981,10.148 10.974,10.189 C10.965,10.231 10.951,10.271 10.937,10.312 C10.922,10.357 10.907,10.401 10.885,10.443 C10.867,10.48 10.848,10.514 10.824,10.548 C10.813,10.564 10.812,10.583 10.8,10.6 L7.8,14.6 C7.604,14.862 7.303,15 6.999,15 C6.791,15 6.58,14.935 6.4,14.8 C5.958,14.469 5.869,13.842 6.2,13.4 L7.701,11.4 C7.824,11.235 7.707,11 7.5,11 L1,11 C0.448,11 0,11.448 0,12 L0,19 C0,19.552 0.448,20 1,20 L13,20 C13.552,20 14,19.552 14,19 L14,1 C14,0.448 13.552,0 13,0",
  id: "path-1"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "-3 0 20 20"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/disconect.4aba05c7.svg";
export { SvgComponent as ReactComponent };